import { render, staticRenderFns } from "./DepartUserIdCreateRuleModal.vue?vue&type=template&id=bdeb5cac&scoped=true"
import script from "./DepartUserIdCreateRuleModal.vue?vue&type=script&lang=js"
export * from "./DepartUserIdCreateRuleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdeb5cac",
  null
  
)

export default component.exports